import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuDropdown, MenuItem } from '@features/events/common';
import { ArrowDown } from '@shared/assets';
import { useCommonMenu } from '@shared/ui';
import * as st from './styles.module.scss';

interface PaymentMethodProps {
  fieldName: string;
  disabled?: boolean;
  // index:number;
}

export const PaymentMethod = ({ fieldName, disabled = false }: PaymentMethodProps): JSX.Element => {
  const { control } = useFormContext();
  const { onClose, onOpen, popperEl, referenceEl, setPopperEl, setReferenceEl } = useCommonMenu();

  const paymentMethods = [
    { label: 'Наличные', value: 'C' },
    { label: 'Интернет эквайринг', value: 'O' },
  ];

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <div className={cn(st.wrapper, disabled && st.disabled)}>
          <div className={st.payment}>
            <div
              className={cn(st.payment__field, error && st.payment__error)}
              onClick={onOpen}
              ref={setReferenceEl}
            >
              {value ? (
                <span>{paymentMethods.find((method) => method.value === value)?.label}</span>
              ) : (
                <span className={st.default} />
              )}
              <span className={st.payment__label}>Способ оплаты</span>
              <div className={st.icon}>
                <ArrowDown />
              </div>
              <MenuDropdown popperEl={popperEl} referenceEl={referenceEl} setPopperEl={setPopperEl}>
                {paymentMethods.map((method, index) => (
                  <MenuItem
                    key={index}
                    onClick={(e) => {
                      onChange(method.value);
                      onClose(e);
                    }}
                    className={st.payment__item}
                  >
                    {method.label}
                  </MenuItem>
                ))}
              </MenuDropdown>
            </div>
          </div>
        </div>
      )}
    />
  );
};
